import { render, staticRenderFns } from "./DynamicBoard.vue?vue&type=template&id=77c2fd50"
import script from "./DynamicBoard.vue?vue&type=script&lang=ts"
export * from "./DynamicBoard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports